import React from 'react';
import FilterPillSlider from './FilterPillSlider.tsx';
import { DIFFICULTY_LABELS, DIFFICULTY_LEVELS, DifficultyBucket } from './difficulty.ts';

type DifficultyPillSliderProps = {
  value: DifficultyBucket | null;
  onChange: (value: DifficultyBucket | null) => void;
  disabled?: boolean;
};

const DifficultyPillSlider: React.FC<DifficultyPillSliderProps> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <FilterPillSlider
    title="Difficulty"
    levels={DIFFICULTY_LEVELS}
    labels={DIFFICULTY_LABELS}
    value={value}
    onChange={onChange}
    disabled={disabled}
  />
);

export default DifficultyPillSlider;
